<template>
  <div>
    <div
      class="prose-p:text-lg mb-2 overflow-hidden"
      :class="{'max-lg:line-clamp-3': !readMore}"
      v-html="text"
    />

    <button
      v-if="!readMore"
      class="text-xs underline underline-offset-2 lg:hidden"
      @click="readMore = true"
    >
      {{ $t('Read more') }}
    </button>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  text: string
}>();

const readMore = ref(false);
</script>
